import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-replace",
  "use": "icon-replace-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-replace\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" /> \n\t<path d=\"M9,12.6l3,3V13.8h2.4V12.6Zm3-2.4H9.6v1.2H15l-3-3ZM6.6,6.6H17.4a.6.6,0,0,1,.6.6v9.6a.6.6,0,0,1-.6.6H6.6a.6.6,0,0,1-.6-.6V7.2A.6.6,0,0,1,6.6,6.6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol